module.exports = __webpack_public_path__ + "static/img/GuardGroupInfo.34ec4d8d.png";